import {Component} from 'react';
import * as React from 'react';

const CANVAS_STYLE = {
    position: 'absolute',
    left: 0,
    pointerEvents: 'none'
};

const NUM_CONFETTI = 40;
const GRAVITY_PX_PER_SECOND_SQUARED = 100;
const TRIANGLE_CONFETTI_COLOR = 'rgb(245, 152, 147)';
const SQUARE_CONFETTI_COLOR = 'rgb(191, 176, 217)';
const SQUIGGLY_CONFETTI_COLOR = 'rgb(151, 221, 221)';

/* istanbul ignore next */
class ConfettiDiv extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            div: null,
            canvas: null
        };

        this.lastTime = null;
        this.init = false;
        this.confetti = [];

        this._divRef = this._divRef.bind(this);
        this._canvasRef = this._canvasRef.bind(this);
        this._canvasRender = this._canvasRender.bind(this);
    }

    componentDidMount() {
        this.rafReqId = requestAnimationFrame(this._canvasRender);
        if (this.hasRAF) {
            this.rafReqId = requestAnimationFrame(this._canvasRender);
        }
    }

    componentWillUnmount() {
        if (this.hasRAF) {
            cancelAnimationFrame(this.rafReqId);
        }
    }

    _divRef(el) {
        this.setState({
            div: el
        });
    }

    _canvasRef(el) {
        this.setState({
            canvas: el
        });
    }

    _canvasRender(time) { // eslint-disable-line complexity
        const delta = this.lastTime ? (time - this.lastTime) / 1000 : 0;
        const canvas = this.state.canvas;
        const width = +canvas.style.width.replace('px', '');
        const height = +canvas.style.height.replace('px', '');

        const pixelRatio = devicePixelRatio || 1;
        canvas.width = width * pixelRatio;
        canvas.height = height * pixelRatio;

        const ctx = canvas.getContext('2d');
        this.lastTime = time;

        ctx.save();
        ctx.scale(pixelRatio, pixelRatio);

        if (this.init === false) {
            // Initialize the entity list
            for (let i = 0; i < NUM_CONFETTI; i++) {
                const x = (width / 2) + ((Math.random() - 0.5) * 2) * width;
                const y = height * (Math.random() * 0.5);
                const velocityX = (Math.random() - 0.5) * 2 * 50;
                const velocityY = (-Math.random()) * 100 - 50;
                const rotation = Math.random() * Math.PI;
                const rotationalVelocity = ((Math.random() - 0.5) * 2) * Math.PI;
                const sprite = Math.floor(Math.random() * 3);
                const e = {
                    x,
                    y,
                    velocityX,
                    velocityY,
                    rotation,
                    rotationalVelocity,
                    sprite
                };
                this.confetti.push(e);
            }
            this.init = true;
        }

        // Integrate physics
        for (const e of this.confetti) {
            e.velocityY += GRAVITY_PX_PER_SECOND_SQUARED * delta;
            e.x += e.velocityX * delta;
            e.y += e.velocityY * delta;
            e.rotation += e.rotationalVelocity * delta;
        }

        // Render sprites
        for (const e of this.confetti) {
            ctx.save();
            ctx.translate(e.x, e.y);
            ctx.rotate(e.rotation);

            switch (e.sprite) {
                case 0:
                    // triangle
                    ctx.fillStyle = TRIANGLE_CONFETTI_COLOR;
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.lineTo(16, 0);
                    ctx.lineTo(0, 16);
                    ctx.fill();
                    break;
                case 1:
                    // square
                    ctx.fillStyle = SQUARE_CONFETTI_COLOR;
                    ctx.fillRect(-6, -6, 12, 12);
                    break;
                case 2:
                    // squiggly
                    ctx.strokeStyle = SQUIGGLY_CONFETTI_COLOR;
                    ctx.lineWidth = 4;
                    ctx.beginPath();
                    ctx.moveTo(-16, 0);
                    ctx.arcTo(-8, 8, 0, 0, 8);
                    ctx.arcTo(8, -8, 16, 0, 8);
                    ctx.stroke();
                    break;
                default: break;
            }

            ctx.restore();
        }

        // next frame
        ctx.restore();
        this.rafReqId = requestAnimationFrame(this._canvasRender);
    }

    render() {
        const {
            children,
            ...props
        } = this.props;

        const canvasWidth = this.props.width;
        const canvasHeight = this.props.height;

        return (
            <div {...props} ref={this._divRef}>
                <canvas
                    className="confetti"
                    ref={this._canvasRef}
                    style={{
                        width: canvasWidth,
                        height: canvasHeight,
                        ...CANVAS_STYLE
                    }}
                />
                {children}
            </div>
        );
    }
}

export default ConfettiDiv;
